export default () => {
  // 指導員に再受講を指示されたものの受講履歴に「却下」の処理がされておらず、
  // 教習生が複数回受講してしまいせっかく受講したのに受講確認ができず、
  // 無効になったケースがあったための注意喚起ダイアログボックスを出す処理
  const attenadanceStartBtn = document.getElementById('attendance-start-button');
  if (!attenadanceStartBtn) return;

  const isMultipleWatching = attenadanceStartBtn.dataset.isMultipleWatching;
  if (!isMultipleWatching) return;

  attenadanceStartBtn.addEventListener('click', (e) => {
    const message =
      '復習用に動画の再視聴を開始します、よろしいですか？\n\n※一度目の受講の受け直しを指示された場合や、一度目の受講をエラー等により受け直しをする場合はこの教程が「却下」又は「キャンセル」と表示されるまで待ってから受け直してください。';

    if (!window.confirm(message)) {
      e.stopPropagation();
      e.preventDefault();
    }
  });
};
